module.exports = __webpack_public_path__ + "media/metal_sheet_2.d7275891.webm";